import { DocumentNode, gql } from '@apollo/client'

export const CREATE_TASK_NOTE: DocumentNode = gql`
    mutation CreateTaskNote($daycareId: Int!, $taskNote: TasNoteInput!) {
        createTaskNote(daycareId: $daycareId, taskNote: $taskNote)
    }
`

export const DELETE_TASK_NOTE: DocumentNode = gql`
    mutation DeleteTaskNote($daycareId: Int!, $taskNoteId: Int!) {
        deleteTaskNote(daycareId: $daycareId, taskNoteId: $taskNoteId)
    }
`

export const UPDATE_TASK_NOTE: DocumentNode = gql`
    mutation UpdateTaskNote($daycareId: Int!, $taskNoteId: Int!, $taskNote: TasNoteInput!) {
        updateTaskNote(daycareId: $daycareId, taskNoteId: $taskNoteId, taskNote: $taskNote)
    }
`
